// return an auth object if env is not dev or prod and cached creds are available
export function LocalAutoLoginAuth() {
  if (
    !['development', 'production', undefined].includes(
      process.env.REACT_APP_STAGE,
    ) &&
    !!process.env?.REACT_APP_USER &&
    !!process.env?.REACT_APP_TOKEN
  ) {
    return {
      user: process.env.REACT_APP_USER!,
      token: process.env.REACT_APP_TOKEN!,
      db: 'testABR',
    }
  } else {
    return undefined
  }
}
